/**
 * Stats Count up animation
 * @param {*} CountUp Countup plugin
 */
export default function(CountUp) {

  if ($('.stats__number-js').length === 0) {
    return;
  }

  /**
   * Return number of decimal places in input float.
   * @param {*} number Floating point number
   * @return {number} Number of decimal places
   */
  function decimalsCount(number) {
    const num = parseFloat(number);

    if (Math.floor(num.valueOf()) === num.valueOf()) {
      return 0;
    }

    return num.toString().split('.')[1].length || 0;
  }

  /**
   * Run counting animation up to target value.
   */
  function animateStats() {
    $('.stats__number-js').each(function() {
      const targetCount = $(this).attr('data-target-number');
      const decimals = decimalsCount(targetCount);

      const countUp = new CountUp(this, targetCount, {
        duration: 2.5,
        useEasing: true,
        decimalPlaces: decimals,
      });

      countUp.start();
    });
  }

  const number = document.querySelector('.stats__stats--js');
  const observer = new IntersectionObserver(function(entries) {
    if (entries[0].isIntersecting) {
      observer.unobserve(number);
      animateStats(CountUp);
    }
  }, {
    threshold: [1]
  });
  observer.observe(number);
}
